export enum FineStatusStage {
  Notification = 'notification',
  DriverIdentification = 'driverIdentification',
  PaidToAuthority = 'paidToAuthority',
  Reimbursed = 'reimbursed',
}

export enum TrafficLightBucket {
  Urgent = 'urgent',
  Approaching = 'approaching',
  OnTime = 'onTime',
}

export type DriverIdentificationState =
  | 'identified'
  | 'notIdentified'
  | 'pending'
  | null;

export interface MultasKpiSummary {
  totalFines: number;
  vehiclesInvolved: number;
  awaitingDriverIdentification: number;
  totalAuthorityAmount: number;
  platesWithFines: number;
  fleetTotal: number;
}

export interface MultasStatusTimelineSummary {
  notification: number;
  driverIdentification: number;
  paidToAuthority: number;
  reimbursed: number;
}

export interface MultasTrafficLightSummary {
  urgent: number;
  approaching: number;
  onTime: number;
  total: number;
}

export interface MultasFine {
  fineId: string;
  aitCode: string;
  plate: string;
  model: string;
  infractionDescription: string;
  location: string;
  occurrenceAt: string;
  notificationDate: string;
  authorityAmount: number;
  indicationDeadline: string | null;
  lakeStatus: string;
  isReimbursed: boolean;
  pagaAoOrgao: boolean;
  reembolsavelAVamos: boolean;
  statusStage: FineStatusStage;
  driverIdentificationState: DriverIdentificationState;
  indicatedDriverName: string | null;
  hasNotificationPdf: boolean;
  trafficLightBucket: TrafficLightBucket | null;
}

export interface MultasPlateGroup {
  plate: string;
  model: string;
  fineCount: number;
  totalAuthorityAmount: number;
  pendingActionsCount: number;
  fineIds: string[];
}

export interface TopVehicleRankingItem {
  rank: number;
  plate: string;
  model: string;
  fineCount: number;
  totalAuthorityAmount: number;
}

export interface TopIndicatedDriverItem {
  rank: number;
  driverName: string;
  driverKey: string;
  fineCount: number;
  distinctPlatesCount: number;
}

export interface MultasListFilters {
  statusStage: FineStatusStage | null;
  trafficLightBucket: TrafficLightBucket | null;
  plateFilter: string | null;
  aitFilter: string | null;
  columnPlates: string[];
  indicatedDriverKey: string | null;
  page: number;
  pageSize: number;
}

export interface IdentifyDriverModalContext {
  fineId: string;
  aitCode: string;
  plate: string;
  infractionDescription: string;
  indicationDeadline: string;
  occurrenceAt: string;
  location: string;
  isExpired: boolean;
  trafficLightBucket: TrafficLightBucket;
  daysRemaining: number;
}

export interface MultasCentralModalContext {
  fineId: string;
  aitCode: string;
  plate: string;
  infractionDescription: string;
}


export const DEFAULT_MULTAS_FILTERS: MultasListFilters = {
  statusStage: null,
  trafficLightBucket: null,
  plateFilter: null,
  aitFilter: null,
  columnPlates: [],
  indicatedDriverKey: null,
  page: 1,
  pageSize: 10,
};
